// extracted by mini-css-extract-plugin
export default {"slideUp":"react-data-grid-drop-target__slideUp"};